import { fetchStocks } from "./inventoryAction";
import { formatData, sortByDateReverse } from "./utils";
import { fetchCommercialStocks } from "./commercialReaAction";

export function fetchCommercialReturns(){
    console.log("FIRED ACTION FETCH COMMERCIAL_RETURNS" )
    return async function(dispatch){
        dispatch({ type: "FETCH_COMMERCIAL_RETURNS_START", payload: "" })
        try {
            const response = await fetch('/stocks/commercial/rectif/list',{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            }); 
            
            const realist = await response.json()
            console.log(realist)// realist returns new object created

            if(!realist.error){ // no errors, return new Object
                dispatch({ type: "GET_COMMERCIAL_RETURNS", payload: formatData(sortByDateReverse(realist)) })
                dispatch({ type: "FETCH_COMMERCIAL_RETURNS_FULFILLED", payload:"" })
                console.log("realist fetched")
            
            } else {
                dispatch({
                    type: "FETCH_COMMERCIAL_RETURNS_ERROR",
                    payload: realist.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_COMMERCIAL_RETURNS_ERROR",
                payload: err
                
            })
        }
    }
}

export function createCommercialReturn(newCommercialReturn){
    console.log("FIRED ACTION CREATE COMMERCIAL_RETURN", newCommercialReturn)
    return async function(dispatch){
        dispatch({ type: "CREATE_COMMERCIAL_RETURN_START", payload: "" })
        try {
            const response = await fetch('/stocks/commercial/rectif/new',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    data:newCommercialReturn
                }),
                credentials: 'same-origin',
            }); 
            
            const createdCommercialReturn = await response.json()
            console.log(createdCommercialReturn)// createdCommercialReturn returns new object created

            if(createdCommercialReturn.id){ // no errors, return new Object
                dispatch({
                    type:"NEW_COMMERCIAL_RETURN",
                    payload: createdCommercialReturn
                })

                dispatch({ type: "CREATE_COMMERCIAL_RETURN_FULFILLED", payload:"" })                

                dispatch(fetchCommercialStocks())
                dispatch(fetchStocks())
            } else {
                dispatch({
                    type: "CREATE_COMMERCIAL_RETURN_ERROR",
                    payload: createdCommercialReturn.error.message
                })
            }
            
        } catch (err) {
            console.log('====================================');
            console.log("error create rea", err);
            console.log('====================================');
            dispatch({
                type: "CREATE_COMMERCIAL_RETURN_ERROR",
                payload: err
                
            })
        }
    }
}

export function deleteCommercialReturn(rea){
    return async function(dispatch){
        dispatch({ type: "DELETE_COMMERCIAL_RETURN_START", payload: "" })
        try {
            const response = await fetch('/stocks/commercial/delete',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    data:rea
                }),
                credentials: 'same-origin',
            }); 
            const body = await response.json()
            console.log("DELETE COMMERCIAL_RETURN RESPONSE",{body})

            if(!body.error){ // no errors, return new Object
                dispatch({ type: "DELETE_COMMERCIAL_RETURN", payload: rea.id })
                dispatch({ type: "DELETE_COMMERCIAL_RETURN_FULFILLED", payload:"" })
                dispatch(fetchStocks())
            } else {
                dispatch({
                    type: "DELETE_COMMERCIAL_RETURN_ERROR",
                    payload: body.error.message
                })
            }
        } catch (err) {
            dispatch({  type: "DELETE_COMMERCIAL_RETURN_ERROR", payload: err })
        }
    }
}

function sortByDate(list, field = 'date') {
    // console.log(list);
    let newList = {}
    list.sort( (a, b) => {
        return new Date(b[field]) - new Date(a[field])
    });

    list.map( item => {
        newList[item.id] = item
    })

    // console.log('====================================');
    // console.log({ newList, list});
    // console.log('====================================');
    return newList
  } 